
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{staticClass:"toStroke",attrs:{"stroke":"#042132","stroke-width":"1.531","d":"M.765 2.559h22.469v15.924H.765z"}}),_c('path',{attrs:{"d":"M10.02 15.583A6.625 6.625 0 003.458 21.3c-.104.76.528 1.332 1.215 1.332h10.695c.686 0 1.318-.572 1.214-1.332a6.625 6.625 0 00-6.562-5.717zM10.268 15.318a4.3 4.3 0 100-8.599 4.3 4.3 0 000 8.599z","fill":"#fff","stroke":"#fff","stroke-width":".851"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M4.673 21.441a.079.079 0 01-.031-.006 5.434 5.434 0 0110.757 0 .079.079 0 01-.031.006H4.673zM13.377 11.019a3.108 3.108 0 11-6.217 0 3.108 3.108 0 016.217 0z","stroke":"#042132","stroke-width":"1.531"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    